module.exports = __webpack_public_path__ + "img/selected1-min.dbcf8151.png";